import React, { useEffect } from "react";

const ConfirmModal = ({ onSubmit, isOpen, onClose, text }) => {
    // Close modal on Escape key
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape" && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            // Prevent body scroll when modal is open
            document.body.style.overflow = "hidden";
        }

        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.body.style.overflow = "unset";
        };
    }, [isOpen, onClose]);

    const handleSubmit = () => {
        if (onSubmit) {
            onSubmit();
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleBackdropClick = (e) => {
        // Close modal if clicking on the backdrop (not the modal content)
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
            onClick={handleBackdropClick}
            style={{ pointerEvents: 'auto' }}
        >
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6" onClick={(e) => e.stopPropagation()}>
                <p className="text-lg text-gray-800 mb-6 text-center">
                    {text}
                </p>
                <div className="flex gap-3 justify-end">
                    <button
                        type="button"
                        onClick={handleClose}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors font-medium"
                    >
                        Stäng
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors font-medium"
                    >
                        Bekräfta
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
